"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

/**
Hook to load an SVG via fetch
and insert into dom
and also save to localStorage
*/
function useLocalStorageSVG(_ref) {
  var url = _ref.url,
      id = _ref.id,
      version = _ref.version;
  (0, _react.useEffect)(function () {
    if (!document.getElementById(id)) {
      var svgVersion = localStorage && localStorage.getItem(id + "-version") || null;
      var svgData = localStorage && localStorage.getItem(id) || null;

      if (!svgData || svgVersion !== "" + version) {
        try {
          fetch(url).then(function (response) {
            if (!response.ok) {
              return '';
            }

            return response.text();
          }).then(function (svg) {
            document.body.insertAdjacentHTML('beforeend', svg);

            try {
              /* mobile safari in private mode always fails localStorage */
              localStorage.setItem(id, svg);
              localStorage.setItem(id + "-version", version);
            } catch (e) {
              /* so lint doesn't complain */
            }
          });
        } catch (e) {
          /* added so tests don't choke, we dont really support browsers that don't do fetch() */
        }
      } else {
        document.body.insertAdjacentHTML('beforeend', svgData);
      }
    }
  }, [id, url, version]);
}

var _default = useLocalStorageSVG;
exports["default"] = _default;